export function ConfigurationPage() {
  return (
    <main className="center-page">
      <section className="message-card">
        <p className="eyebrow">CONFIGURATION</p>
        <h1>还差数据库连接配置</h1>
        <p>
          请在本地 <code>.env.local</code> 或 EdgeOne 构建环境变量中设置
          <code> VITE_SUPABASE_URL</code> 和
          <code> VITE_SUPABASE_PUBLISHABLE_KEY</code>。
        </p>
        <p className="quiet">真实配置不会写入 Git，也不需要发送到聊天中。</p>
      </section>
    </main>
  );
}
